<template>
  <div class="row">
    <div class="col-xl-12">
      <!-- begin: Single Modal -->
      <router-view />
      <!-- end: Single Modal -->

      <div
        v-show="$route.path == '/Master/ManageShop'"
        class="kt-portlet kt-portlet--mobile"
      >
        <div class="kt-portlet__head kt-portlet__head--lg">
          <div class="kt-portlet__head-label">
            <span class="kt-portlet__head-icon">
              <i class="fa fa-store"></i>
            </span>
            <h3 class="kt-portlet__head-title">จัดการข้อมูลร้านค้า</h3>
          </div>
        </div>
        <div class="kt-portlet__body">
          <!-- begin: Search Form -->
          <form class="kt-form" @submit="formSubmit" ref="searchForm">
            <div class="row">
              <div class="col-xl-6 col-lg-6 col-md-6 .col-sm-6 col-xs-6">
                <div class="form-group">
                  <label>คำค้นหา:</label>
                  <input
                    v-model="shmKeyword"
                    type="text"
                    class="form-control"
                    placeholder="ค้นหาจาก รหัส ชื่อร้านค้า ชื่อผู้ติดต่อ เจ้าหน้าที่ดูแล โดยสามารถคั่นระหว่างคำได้ด้วยเครื่องหมายลูกน้ำ เช่น ชื่อร้านค้า 1, ชื่อร้านค้า 2"
                  />
                </div>
              </div>

              <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3">
                <div class="form-group">
                  <label>ตัวแทนจำหน่ายย่อย:</label>
                  <select2
                    :css-style="'width: 100%;'"
                    :css-class="'form-control m-select2'"
                    :id="'shmSubAgent'"
                    :name="'shmSubAgent'"
                    :select2-options="shmSubAgentOptions"
                    v-model="shmSubAgent"
                    ref="shmSubAgentSelect2"
                  ></select2>
                </div>
              </div>

              <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3">
                <div class="form-group">
                  <label>สถานะ:</label>
                  <select2
                    :css-style="'width: 100%;'"
                    :css-class="'form-control m-select2'"
                    :id="'shmInActiveStatus'"
                    :name="'shmInActiveStatus'"
                    :select2-options="shmInActiveStatusOptions"
                    v-model="shmInActiveStatus"
                    ref="shmInActiveStatusSelect2"
                  ></select2>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3">
                <div class="form-group">
                  <label>ประเภทร้านค้า:</label>
                  <treeselect
                    v-model="shmShopTypeId"
                    :multiple="true"
                    :options="shmShopTypeIdOptions"
                    :clear-on-select="true"
                    placeholder="กรุณาเลือก"
                  />
                </div>
              </div>

              <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3">
                <div class="form-group">
                  <label>สถานะประเภทร้านค้า:</label>
                  <treeselect
                    v-model="shmShopGroupId"
                    :multiple="true"
                    :options="shmShopGroupIdOptions"
                    :clear-on-select="true"
                    placeholder="กรุณาเลือก"
                  />
                </div>
              </div>

              <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3">
                <div class="form-group">
                  <label>จังหวัด:</label>
                  <select2
                    :css-style="'width: 100%;'"
                    :css-class="'form-control m-select2'"
                    :id="'shmProvinceId'"
                    :name="'shmProvinceId'"
                    :select2-options="shmProvinceIdOptions"
                    @selectChange="onAmpherIdChange"
                    v-model="shmProvinceId"
                    ref="shmProvinceIdSelect2"
                  ></select2>
                </div>
              </div>

              <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3">
                <div class="form-group">
                  <label>อำเภอ:</label>
                  <select2
                    :css-style="'width: 100%;'"
                    :css-class="'form-control m-select2'"
                    :id="'shmAmpherId'"
                    :name="'shmAmpherId'"
                    :select2-options="shmAmpherIdOptions"
                    v-model="shmAmpherId"
                    ref="shmAmpherIdSelect2"
                  ></select2>
                </div>
              </div>
              <div
                class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"
                v-if="this.$root.canShow('')"
              >
                <div class="form-group">
                  <label>ตัวแทนจำหน่าย :</label>
                  <treeselect
                    v-model="shmAgentCode"
                    :multiple="true"
                    :clear-on-select="true"
                    :options="shmAgentCodeOptions"
                    placeholder="กรุณาเลือก"
                  />
                </div>
              </div>
            </div>
            <div class="row mb-3">
              <div class="col-xl-6">
                <button type="submit" class="btn btn-primary">ค้นหา</button>
                <button
                  type="reset"
                  class="btn btn-secondary"
                  @click="formReset"
                >
                  ล้างค่าทั้งหมด
                </button>
              </div>
              <div class="col-xl-6 text-right">
                <button
                  class="btn btn-outline-primary"
                  @click="exportShop"
                  type="submit"
                >
                  <span>
                    <i class="fas fa-file-export"></i><span>Export Excel</span>
                  </span>
                </button>
                <router-link
                  to="ManageShop/Add"
                  tag="button"
                  title="เพิ่ม"
                  class="btn btn-outline-brand"
                  v-if="this.$root.canShow(['MANAGE_MASTER', 'MANAGE_SHOP'])"
                >
                  <i class="fa fa-plus-circle"></i> เพิ่ม
                </router-link>
              </div>
            </div>
          </form>
          <!-- end: Search Form -->

          <!--begin: Datatable -->
          <div class="row">
            <div class="col-lg-12 ">
              <table
                class="table-sm table-striped- table-bordered table-hover table-checkable"
                id="shopTable"
              >
                <thead>
                  <tr>
                    <th></th>
                    <th class="all">รหัสร้านค้า</th>
                    <th class="all">ชื่อร้านค้า</th>
                    <th class="all">ชื่อร้านค้า 2</th>
                    <th class="all">ประเภทร้านค้า</th>
                    <th class="all">สถานะประเภทร้านค้า</th>
                    <th class="all">ผู้ดูแลร้านค้า</th>
                    <th class="all">ตัวแทนจำหน่ายย่อย</th>
                    <th class="none">ที่อยู่</th>
                    <th class="none">อีเมล</th>
                    <th class="all">เบอร์โทร</th>
                    <th class="all">ชื่อผู้ติดต่อ</th>
                    <th class="none">เจ้าหน้าที่ดูแล (ตัวแทน)</th>
                    <th class="none">เจ้าหน้าที่ดูแล (boonrawd)</th>
                    <th class="all">อำเภอ</th>
                    <th class="all">จังหวัด</th>
                    <th class="none">Latitude</th>
                    <th class="none">Longitude</th>
                    <th class="all">สถานะ</th>
                    <th class="all">การจัดการ</th>
                  </tr>
                </thead>
              </table>
            </div>
          </div>
          <!--end: Datatable -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import router from "../../../router";
import select2 from "../../../Shared/Select2";
import axios from "axios";
// import the component
import Treeselect from "@riophae/vue-treeselect";
// import the styles
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import DatatableWarning from "../../../Shared/DatatableWarning";

require("datatables.net-autofill-bs4");
require("datatables.net-bs4");
require("datatables.net-buttons-bs4");
require("datatables.net-colreorder-bs4");
require("datatables.net-fixedcolumns-bs4");
require("datatables.net-fixedheader-bs4");
require("datatables.net-keytable-bs4");
require("datatables.net-responsive-bs4");
require("datatables.net-rowgroup-bs4");
require("datatables.net-rowreorder-bs4");
require("datatables.net-scroller-bs4");
require("datatables.net-select-bs4");
require("sweetalert2");

let StatusActionsTrue = Vue.extend({
  template: `
  <div>
    <a href="#" v-if="data.showEditStatusButton" class="btn btn-sm btn-success" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"> 
      <i class="fas fa-play"></i>เปิดใช้งาน
    </a>
    <div class="dropdown-menu dropdown-primary">
    <p class="text-center">กรุณาเลือกเหตุผล</p>
    <a class="dropdown-item" href="#" @click.prevent="toggleStatus(item)" v-for="item in self.shmInActive"> - {{item.statusName}}</a>
    </div>
  </div>`,
  methods: {
    toggleStatus: function(e) {
      let self = this;
      var table = $("#shopTable");
      Swal.fire({
        title: "คำสั่งแก้ไขสถานะ",
        type: "warning",
        html:
          "กรุณายืนยันคำสั่งแก้ไขสถานะ <strong>" +
          "</strong> หลังจากกดแล้วจะส่งผลให้สถานะถูกปิดใช้งาน" +
          "</strong> *หมายเหตุ " +
          e.statusName +
          "",
        inputPlaceholder: "ต้องการแก้ไขสถานะ",
        showCancelButton: true,
        confirmButtonText: "ยืนยัน",
        cancelButtonText: "ยกเลิก",
        showLoaderOnConfirm: true,
      }).then((result) => {
        if (result.value === true || result.value === false) {
          KTApp.blockPage({
            opacity: 0.05,
            message: "กำลังแก้ไข้ข้อมูล กรุณารอสักครู่...",
          });

          axios
            .put(
              "/Api/Shop/" +
                this.data.customerCode +
                "/" +
                e.statusCode +
                "/Toggle"
            )
            .then(function(response) {
              if (response.data.data) {
                self.$parent.reloadDataTable();
                Swal.fire("สำเร็จ", response.data.message, "success");
              } else {
                Swal.fire(
                  "เกิดข้อผิดพลาด",
                  error.response.data.message,
                  "error"
                );
              }
            })
            .catch(function(error) {
              Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
            })
            .then(function() {
              // always executed
              KTApp.unblockPage();
            });
        }
      });
    },
  },
});
let StatusActionsFalse = Vue.extend({
  template: `
  <div>
    <a href="#"  v-if="data.showEditStatusButton" @click = "returnActive" class="btn btn-sm btn-danger" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
      <i class="fas fa-pause"></i>ปิดใช้งาน
    </a>
    <div class="dropdown-menu dropdown-primary">
    <p class="text-center">กรุณาเลือกเหตุผล</p>
    <a class="dropdown-item" href="#" @click.prevent="toggleStatus(item)" v-for="item in self.shmFilterActive"> - {{item.statusName}}</a>
    </div>
  </div>`,
  methods: {
    returnActive() {
      if (this.data.reason == "STATUS_SHOP_INACTIVE_CLOSE") {
        this.self.shmFilterActive = this.self.shmActive.filter(
          (o) =>
            //o.statusCode == "STATUS_SHOP_ACTIVE_NEW" ||
            o.statusCode == "STATUS_SHOP_ACTIVE_CLOSE"
        );
      } else if (this.data.reason == "STATUS_SHOP_INACTIVE_CHANGE") {
        this.self.shmFilterActive = this.self.shmActive.filter(
          (o) =>
            //o.statusCode == "STATUS_SHOP_ACTIVE_NEW" ||
            o.statusCode == "STATUS_SHOP_ACTIVE_COMEBACK"
        );
      } else if (this.data.reason == "STATUS_SHOP_INACTIVE_BEER") {
        this.self.shmFilterActive = this.self.shmActive.filter(
          (o) =>
            //o.statusCode == "STATUS_SHOP_ACTIVE_NEW" ||
            o.statusCode == "STATUS_SHOP_ACTIVE_BEER"
        );
      }
      else if(this.data.reason == "STATUS_SHOP_INACTIVE_DUPLICATE") {
        this.self.shmFilterActive = this.self.shmActive.filter(
            (o) =>
                //o.statusCode == "STATUS_SHOP_ACTIVE_NEW" ||
                o.statusCode == "STATUS_SHOP_ACTIVE_CLOSE" ||
                o.statusCode == "STATUS_SHOP_ACTIVE_COMEBACK" ||
                o.statusCode == "STATUS_SHOP_ACTIVE_BEER" 
                

        );
      }
      else
      {
        this.self.shmFilterActive = this.self.shmActive;
      }

      return this.self.shmFilterActive;
    },
    toggleStatus: function(e) {
      let self = this;
      var rolsCek = this.$root.canShow(["super_admin"]);
      if (this.data.reason == "STATUS_SHOP_INACTIVE_STOP" && !rolsCek) {
        Swal.fire(
          "เกิดข้อผิดพลาด",
          "ไม่สามารถเปิดใช้งานได้ เนื่องจาก คุณไม่ได้รับอนุญาตให้เปลี่ยนสถานะร้านที่ปิดกิจการถาวร",
          "error"
        );
      } else if (this.data.reason == "STATUS_SHOP_INACTIVE_DUPLICATE" && !rolsCek) {
        Swal.fire(
          "เกิดข้อผิดพลาด",
          "ไม่สามารถเปิดใช้งานได้ เนื่องจาก ร้านค้าซ้ำในระบบ",
          "error"
        );
      } else {
        var table = $("#shopTable");
        Swal.fire({
          title: "คำสั่งแก้ไขสถานะ",
          type: "warning",
          html:
            "กรุณายืนยันคำสั่งแก้ไขสถานะ <strong>" +
            "</strong> หลังจากกดแล้วจะส่งผลให้สถานะถูกเปิดใช้งาน" +
            "</strong> *หมายเหตุ " +
            e.statusName +
            "",
          inputPlaceholder: "ต้องการแก้ไขสถานะ",
          showCancelButton: true,
          confirmButtonText: "ยืนยัน",
          cancelButtonText: "ยกเลิก",
          showLoaderOnConfirm: true,
        }).then((result) => {
          if (result.value === true || result.value === false) {
            KTApp.blockPage({
              opacity: 0.05,
              message: "กำลังแก้ไข้ข้อมูล กรุณารอสักครู่...",
            });

            axios
              .put(
                "/Api/Shop/" +
                  this.data.customerCode +
                  "/" +
                  e.statusCode +
                  "/Toggle"
              )
              .then(function(response) {
                if (response.data.data) {
                  self.$parent.reloadDataTable();
                  Swal.fire("สำเร็จ", response.data.message, "success");
                } else {
                  Swal.fire(
                    "เกิดข้อผิดพลาด",
                    error.response.data.message,
                    "error"
                  );
                }
              })
              .catch(function(error) {
                Swal.fire(
                  "เกิดข้อผิดพลาด",
                  error.response.data.message,
                  "error"
                );
              })
              .then(function() {
                // always executed
                KTApp.unblockPage();
              });
          }
        });
      }
    },
  },
  computed: {},
});
let Action = Vue.extend({
  template: `
  <div>
    <a href="#" @click.prevent="edit" v-if="data.showEditButton" title="แก้ไข" class="btn btn-sm btn-clean btn-icon btn-icon-md">
      <i class="la la-edit"></i>
    </a>
     <a href="#" @click.prevent="deleteShop" v-if="data.showDeleteButton" title="ลบ" class="btn btn-sm btn-clean btn-icon btn-icon-md">
      <i class="la la-trash"></i>
    </a>
  </div>`,
  methods: {
    edit: function() {
      router.push({
        path: `/Master/ManageShop/Edit/${this.data.customerCode}`,
      });
    },
    deleteShop: function() {
      Swal.fire({
        title: "ลบข้อมูล",
        type: "warning",
        text: "ต้องการลบข้อมูลหรือไม่ ?",
        showCancelButton: true,
        confirmButtonColor: "#d33",
        confirmButtonText: "ตกลง",
        cancelButtonText: "ยกเลิก",
      }).then(function(result) {
        if (result.value) {
          //Swal.fire({ type: "success", text: "You have a bike!" });
        } else if (result.value === 0) {
          //Swal.fire({ type: "error", text: "You don't have a bike :(" });
        } else {
          //console.log(`modal was dismissed by ${result.dismiss}`);
        }
      });
    },
  },
});

export default {
  components: {
    select2,
    Treeselect,
  },
  data: function() {
    var self = this;

    return {
      shmKeyword: null,
      shmInActiveStatus: null,
      shmShopTypeId: [],
      shmShopGroupId: [],
      shmAgentCode: [],
      shmProvinceId: null,
      shmAmpherId: null,
      shmSubAgent: null,
      shmStatus: null,
      InActiveStatus: null,
      shmActive: [],
      shmInActive: [],
      shmFilterActive: [],
      //config
      shmInActiveStatusOptions: {
        placeholder: "ทั้งหมด",
        allowClear: true,
        data: [
          { id: "false", text: "ใช้งาน", data: null },
          { id: "true", text: "ปิดใช้งาน", data: null },
        ],
      },
      shmSubAgentOptions: {
        placeholder: "ทั้งหมด",
        allowClear: true,
        data: [
          { id: "true", text: "ใช่", data: null },
          { id: "false", text: "ไม่ใช่", data: null },
        ],
      },
      shmShopTypeIdOptions: [],
      shmShopGroupIdOptions: [],
      shmProvinceIdOptions: {
        placeholder: "กรุณาเลือก",
        allowClear: true,
        ajax: {
          url: "/Api/MasterLocation/Select2SearchProvince",
          type: "post",
          dataType: "json",
          contentType: "application/json",
          data: function(params) {
            var query = {
              search: params.term,
              page: params.page || 1,
            };
            return JSON.stringify(query);
          },
          processResults: function(data, params) {1
            return {
              results: data.results,
              pagination: {
                more: data.more,
              },
            };
          },
          transport: function(params, success, failure) {
            params.beforeSend = function(request) {
              request.setRequestHeader(
                "Authorization",
                "Bearer " + self.$root.user.access_token
              );
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          },
        },
      },
      shmAmpherIdOptions: {
        placeholder: "กรุณาเลือก",
        allowClear: true,
        ajax: {
          url: "/Api/MasterLocation/Select2SearchAmpher",
          type: "post",
          dataType: "json",
          contentType: "application/json",
          data: function(params) {
            var query = {
              provinceId: self.shmProvinceId,
              search: params.term,
              page: params.page || 1,
            };
            return JSON.stringify(query);
          },
          processResults: function(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more,
              },
            };
          },
          transport: function(params, success, failure) {
            params.beforeSend = function(request) {
              request.setRequestHeader(
                "Authorization",
                "Bearer " + self.$root.user.access_token
              );
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          },
        },
      },
      shmAgentCodeOptions: [],
      // shmAgentCodeOptions: {
      //   placeholder: "กรุณาเลือก",
      //   allowClear: true,
      //   ajax: {
      //     url: "/Api/Agents/Select2SearchAgentName",
      //     type: "post",
      //     dataType: "json",
      //     contentType: "application/json",
      //     data: function(params) {
      //       var query = {
      //         search: params.term,
      //         department: null,
      //         province_id: null,
      //         page: params.page || 1,
      //       };
      //       return JSON.stringify(query);
      //     },
      //     processResults: function(data, params) {
      //       return {
      //         results: data.results,
      //         pagination: {
      //           more: data.more,
      //         },
      //       };
      //     },
      //     transport: function(params, success, failure) {
      //       params.beforeSend = function(request) {
      //         request.setRequestHeader(
      //           "Authorization",
      //           "Bearer " + self.$root.user.access_token
      //         );
      //       };
      //       var $request = $.ajax(params);
      //       $request.then(success);
      //       $request.fail(failure);
      //       return $request;
      //     },
      //   },
      // },
    };
  },
  methods: {
    formReset: function(e) {
      this.shmKeyword = "";
      this.shmAgentCode = [];
      this.shmShopTypeId = [];
      this.shmShopGroupId = [];
      //default Active Data
      this.shmInActiveStatus = false;
      $("#shmInActiveStatus")
        .val(this.shmInActiveStatus + "")
        .trigger("change");

      $("#shmShopTypeId")
        .val("")
        .trigger("change");

      $("#shmShopGroupId")
        .val("")
        .trigger("change");

      $("#shmProvinceId")
        .val("")
        .trigger("change");

      $("#shmAmpherId")
        .val("")
        .trigger("change");

      $("#shmSubAgent")
        .val("")
        .trigger("change");

      $("#shmAgentCode")
        .val("")
        .trigger("change");

      this.formSubmit(e);
    },
    formSubmit: function(e) {
      e.preventDefault();
      var table = $("#shopTable").DataTable();
      table.search(this.id | this.name);
      table.column(4).search(this.status != "-1" ? this.status : "");
      table.draw();
    },
    exportShop: function(e) {
      e.preventDefault();
      let self = this;

      KTApp.blockPage({
        opacity: 0.05,
        message: "กำลังโหลดข้อมูล กรุณารอสักครู่...",
      });

      axios({
        method: "post",
        url: "/Api/Report/ExportShop",
        responseType: "arraybuffer",
        data: {
                // CustomerCode: self.shmCustomerCode,
                // CustomerName: self.shmCustomerName,
                // Name2: self.shmName2,
                // Tel: self.shmTel,
                // Firstname: self.shmFirstname,
                // TambolId: self.shmTambolId,
                // AmpherId: self.shmAmpherId,
                // ProvinceId: self.shmProvinceId,
                // Address: self.shmAddress,
                // Email: self.shmEmail,
                // AgentName: self.shmAgentName,
                // SubAgent: self.shmSubAgent,
                // EmployeeName: self.shmEmployeeName,
                // Latitude: self.shmLatitude,
                // Longitude: self.shmLongitude,
                // Reason: self.shmReason
                SearchKeyword: self.shmKeyword,
                ShopTypeId: self.shmShopTypeId,
                ShopGroupId: self.shmShopGroupId,
                ProvinceId: self.shmProvinceId,
                AmpherId: self.shmAmpherId,
                InActiveStatus: self.shmInActiveStatus,
                SubAgent: self.shmSubAgent,
                AgentCodes: self.shmAgentCode
        },
      })
        .then(function(response) {
          if (response.status == "200") {
            let filename = "";
            let contentType = response.headers["content-type"];
            let disposition = response.headers["content-disposition"];

            //===Get Filename===
            if (disposition && disposition.indexOf("attachment") !== -1) {
              var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
              var matches = filenameRegex.exec(disposition);
              if (matches != null && matches[1]) {
                filename = matches[1].replace(/['"]/g, "");
              }
            }
            

            var fname = filename.split("RPT_")[1] ;  
            //Save file
            let blob = new Blob([response.data], { type: contentType });
            let link = document.createElement("a");
            link.href = window.URL.createObjectURL(blob);
            // link.download = "ข้อมูลร้านค้า" + filename;
            link.download = "จัดการข้อมูลร้านค้า_" + fname//+ filename;
            link.click();
          } else if (response.status == "204") {
            Swal.fire(
              "ไม่พบข้อมูล",
              "ไม่พบข้อมูลตามเงื่อนไขที่เลือก",
              "warning"
            );
          }
        })
        .catch(function(error) {
          Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
        })
        .then(function() {
          //self.formReset();
          KTApp.unblockPage();
        });
    },
    reloadDataTable: function(resetPaging = false) {
      $("#shopTable")
        .DataTable()
        .ajax.reload(null, resetPaging);
    },
    onAmpherIdChange: function() {
      $("#shmAmpherId")
        .val("")
        .trigger("change");
    },
    getStatusShop() {
      var self = this;
      axios.get("/Api/Shop/StatusShop").then(function(response) {
        if (response.status == 200) {
          self.shmActive = response.data.filter(
            (o) => o.statusGroup == "STATUS_SHOP_ACTIVE"
          );
          self.shmInActive = response.data.filter(
            (o) => o.statusGroup == "STATUS_SHOP_INACTIVE"
          );
        }
      });
    },
    LoadAgentCodeOptions: function(e) {
      var self = this;
      axios
        .post("/Api/Agents/Select2SearchAgentName", {
          department: null,
          province_id: null,
          page: 1,
        })
        .then(function(response) {
          if (response.status == 200) {
            var data = response.data.results;
            data.forEach((element) => {
              self.shmAgentCodeOptions.push({
                id: element.id,
                label: element.text,
              });
            });
          }
        })
        .catch(function(error) {});
    },
    LoadShopTypeIdOptions: function(e) {
      var self = this;
      axios
        .get("/Api/ShopType/Select2SearchShopType", {
          params: {
            page: 1,
            all: true,
          },
        })
        .then(function(response) {
          if (response.status == 200) {
            var data = response.data.results;
            data.forEach((element) => {
              self.shmShopTypeIdOptions.push({
                id: element.id,
                label: element.text,
              });
            });
          }
        })
        .catch(function(error) {});
    },
    LoadShopGroupIdOptions: function(e) {
      var self = this;
      axios
        .get("/Api/ShopType/Select2SearchShopGroup", {
          params: {
            page: 1,
            all: true,
          },
        })
        .then(function(response) {
          if (response.status == 200) {
            var data = response.data.results;
            data.forEach((element) => {
              self.shmShopGroupIdOptions.push({
                id: element.id,
                label: element.text,
              });
            });
          }
        })
        .catch(function(error) {});
    },
  },
  async mounted() {
    let self = this;
    self.getStatusShop();
    //default Active Data
    self.shmInActiveStatus = false;
    $("#shmInActiveStatus")
      .val(self.shmInActiveStatus + "")
      .trigger("change");

    self.LoadAgentCodeOptions();
    self.LoadShopTypeIdOptions();
    self.LoadShopGroupIdOptions();

    $.fn.dataTable.ext.errMode = 'none';
    var table = $("#shopTable");

    // begin first table
    table
      .DataTable({
        responsive: true,
        processing: true,
        serverSide: true,
        searchDelay: 500,
        ajax: {
          url: "/Api/Shop/Search",
          type: "post",
          dataType: "json",
          contentType: "application/json",
          beforeSend: function(request) {
            request.setRequestHeader(
              "Authorization",
              "Bearer " + self.$root.user.access_token
            );
          },
          data: function(d) {
            //console.log(d);
            return JSON.stringify(
              $.extend(d, {
                SearchKeyword: self.shmKeyword,
                ShopTypeId: self.shmShopTypeId,
                ShopGroupId: self.shmShopGroupId,
                ProvinceId: self.shmProvinceId,
                AmpherId: self.shmAmpherId,
                InActiveStatus: self.shmInActiveStatus,
                SubAgent: self.shmSubAgent,
                AgentCodes: self.shmAgentCode,
              })
            );
          },
        },
        // DOM Layout settings
        dom: `<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>
        <'row'<'col-sm-12'tr>>
  			<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>`,

        lengthMenu: [50, 100, 200, 500],

        pageLength: 100,

        language: {
          lengthMenu: "Display _MENU_",
        },

        // Order settings
        order: [[1, "asc"]],
        columns: [
          {
            data: null,
            className: "details-control",
            defaultContent: "",
            orderable: false,
          },
          { data: "custCode", className: "text-center" },
          { data: "customerName", className: "text-center" },
          { data: "name2", className: "text-center" },
          { data: "shopTypeName", className: "text-center" },
          { data: "shopGroupName", className: "text-center" },
          { data: "agentName", className: "text-center",
            render: function(data, type, full, meta) {
                var html = "<pre style='font-size: 15px; font-weight: 300; font-family: Noto Sans Thai UI;color: #6c7293;display:inline;white-space: pre-wrap; word-break: keep-all;'>"+data+"</pre>";
                return html;
              } 
            },
          {
            data: "subAgent",
            className: "text-center",
            width: "7%",
            orderable: false,
            render: function(data, type, full, meta) {
              if (data == true)
                return '<i class="text-success fa fa-check-circle"></i>';
              else return '<i class="text-danger fa fa-times-circle"></i>';
            },
          },
          { data: "address", className: "text-center" },
          { data: "email", className: "text-center" },
          { data: "tel", className: "text-center" },
          { data: "fullName", className: "text-center" },
          { data: "contactAgentFullName", className: "text-center" },
          { data: "employeeFullName", className: "text-center" },
          { data: "ampherName", className: "text-center", orderable: false },
          { data: "provinceName", className: "text-center", orderable: false },
          { data: "latitude", className: "text-center" },
          { data: "longitude", className: "text-center" },
          {
            data: "inActiveStatus",
            className: "text-center",
            width: "10%",
            orderable: false,
            render: function(data, type, full, meta) {
              return '<div class="actionsStatus"></div>';
            },
          },
          {
            data: "customerCode",
            className: "text-center",
            orderable: false,
            render: function(data, type, full, meta) {
              return '<div class="actions"></div>';
            },
          },
        ],
      })
      .on("preXhr.dt", function() {
        KTApp.block(self.$refs.searchForm, {
          showOverlay: false,
          opacity: 0.05,
          message: "กำลังค้นหาข้อมูล กรุณารอสักครู่...",
        });
      })
      .on("error.dt", function ( e, settings, techNote, message ) {
        DatatableWarning.alert(techNote);
      })
      .on("xhr.dt", function() {
        KTApp.unblock(self.$refs.searchForm);
      })
      .on("draw.dt", function() {
        $(".actionsStatus").each(function(i, el) {
          var $dt = table.DataTable();
          var $tr = $(el)
            .parents("tr")
            .first();
          var data = $dt.row($tr).data();
          if (data) {
            data.showEditStatusButton = self.$root.canShow([
              "MANAGE_MASTER",
              "MANAGE_SHOP",
            ]);

            if (data.inActiveStatus == 0)
              new StatusActionsTrue({
                data: { data, self },
                parent: self,
              }).$mount(el);
            else if (data.inActiveStatus == 1)
              new StatusActionsFalse({
                data: { data, self },
                parent: self,
              }).$mount(el);
          }
        });
        $(".actions").each(function(i, el) {
          var $dt = table.DataTable();
          var $tr = $(el)
            .parents("tr")
            .first();
          var data = $dt.row($tr).data();
          //console.log(data);
          if (data) {
            data.showEditButton = self.$root.canShow([
              "MANAGE_MASTER",
              "MANAGE_SHOP",
            ]);
            new Action({ data: { data }, parent: self }).$mount(el);
          }
        });
      });
    //table.trigger("draw.dt"); //call ajax delete this row
  },
};
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// App/Components/Master/Shop/ManageShop.vue